module.exports = __webpack_public_path__ + "img/faq-km.417afb36.png";